export default {
    show_unit_type_events_title: "Unit Type Events",
    show_unit_type_events_name: "Name",
    show_unit_type_events_raw_event: "Raw Event",
    show_unit_type_events_split_event_index: "Split Event Index",
    show_unit_type_events_split_event_value: "Split Event Value",
    show_unit_type_events_settings: "Settings",
    show_unit_type_events_cloud_config: "Cloud Config",
    show_unit_type_events_compare_vesions: "Changes from version "
}